import React from "react";
import PageHeader from "../../common/HeaderPage";
import { NavLink } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";

export default function MTDBusinessPage() {
  return (
    <section
      id="content"
      className="container clearfix"
      style={{
        padding: "0px",
        outline: "none",
        margin: "0px auto",
        marginBottom: "0px"
      }}
    >
      <PageHeader title={"MTD - Making Tax Digital"}></PageHeader>
      <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <nav>
            <NavLink to="/mtd/business">Business</NavLink>
            {" | "}
            <NavLink to="/mtd/incometaxselfassesment">
              Income Tax Self Assesment
            </NavLink>
            {" | "}
            <NavLink to="/mtd/accountants">Accountants</NavLink>
          </nav>
        </Navbar.Collapse>
      </Navbar>
      <div style={{ margin: "0px", padding: "0px", outline: "none" }}>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            outline: "none",
            marginBottom: "20px"
          }}
        >
          VAT registered businesses are required to keep digital records and
          submit their VAT returns using MTD-compatible software. This is part
          of the UK legislation. We aim to make this process as easy as possible
          for Businesses and their accountants. Our MTD software is designed to
          help businesses comply with these requirements efficiently and
          effectively.
        </p>
      </div>
    </section>
  );
}
